import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import updateBusPartnerDriverCostMutation from '../graphql/updateBusPartnerDriverCostMutation';
import {PartnerCostsDriverCost} from '../store/types';
import {receivedPartnerDriverCost} from '../store/slice';

interface UseUpdateBusPartnerDriverCostMutationResult {
  updateBusPartnerDriverCost: (
    cost: PartnerCostsDriverCost,
    partnerId: string,
    year: number,
    onSuccess?: (cost?: PartnerCostsDriverCost) => void
  ) => Promise<void>;
}

export const useUpdateBusPartnerDriverCostMutation =
  (): UseUpdateBusPartnerDriverCostMutationResult => {
    const dispatch = useAppDispatch();
    const [updateBusPartnerDriverCostEntry] = useMutation(
      updateBusPartnerDriverCostMutation,
      {
        errorPolicy: 'all'
      }
    );

    const updateBusPartnerDriverCost = useCallback(
      async (
        cost: PartnerCostsDriverCost,
        partnerId: string,
        year: number,
        onSuccess?: (cost?: PartnerCostsDriverCost) => void
      ) => {
        try {
          const variables = {
            ...cost,
            partnerId,
            year
          };
          const result = await updateBusPartnerDriverCostEntry({variables});

          if (result.errors && result.errors.length > 0) {
            const errorMessage = result.errors[0].message;
            console.error(errorMessage);
            return;
          }

          dispatch(
            receivedPartnerDriverCost(
              result.data.updateBusPartnerDriverCostEntry
            )
          );
          onSuccess?.(result.data.updateBusPartnerDriverCostEntry);
        } catch (err: any) {
          console.error(
            `Unexpected error while updating bus partner driver cost entry: ${err}`
          );
        }
      },
      [dispatch, updateBusPartnerDriverCostEntry]
    );

    return {updateBusPartnerDriverCost};
  };
